import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxSearcher from '../../cx/CxSearcher';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxIconButton from '../../cx/CxIconButton';
//import { useNav } from '../../hx/useNav';


const MxSettPsMergeGroupForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();
  const r_snack_required = React.useRef(null);
  const r_snack_same_item = React.useRef(null);
  const r_snack_op_in_progress = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_txTypePsGroupToKeep = React.useRef(null);
  const rf_txTypePsGroupToDelete = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);
  
  const doMerge = () => {
    // chequea requeridos
    if (rf_txTypePsGroupToKeep.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsGroupToKeep.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsGroupToDelete.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsGroupToDelete.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsGroupToKeep.current.getKey()===rf_txTypePsGroupToDelete.current.getKey()) {
      r_snack_same_item.current.setOpen(true);
      return;
    }
    
    let itPsGroup_toKeep = rf_txTypePsGroupToKeep.current.getKey();
    let itPsGroup_toDelete = rf_txTypePsGroupToDelete.current.getKey();

    let record = {};
    record['itPsGroup_toKeep'] = itPsGroup_toKeep;
    record['itPsGroup_toDelete'] = itPsGroup_toDelete;
    r_snack_op_in_progress.current.setOpen(true);
    Promise.all([FxFetch.doJsonX(`sett/ps/merge/group/do`, record)]).then((result) => {
      rf_txTypePsGroupToKeep.current.clear();
      rf_txTypePsGroupToDelete.current.clear();
      r_snack_op_in_progress.current.setOpen(false);
      r_snack_op_successful.current.setOpen(true);
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.merge_x', 'field.groups')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={doMerge} tooltip={trans('field.merge_duplicates')} />
          </div>
        }
      >

      <CxSearcher xref={rf_txTypePsGroupToKeep}
        label={trans('field.keep')}
        url="sett/ps_group" 
        tooltip={trans('field.group')}
        col_id="itPsGroup" 
        col_tx="txTypePsGroup"
        columns={[
          { id: "0", Header: "ID", accessor: "itPsGroup", show: false },
          { id: "1", Header: trans('field.group'), accessor: row => rf_txTypePsGroupToKeep.current.getTable().highlightText(row["txTypePsGroup"]), width: '30%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      <CxSearcher xref={rf_txTypePsGroupToDelete}
        label={trans('field.delete')}
        url="sett/ps_group" 
        tooltip={trans('field.group')}
        col_id="itPsGroup" 
        col_tx="txTypePsGroup"
        columns={[
          { id: "0", Header: "ID", accessor: "itPsGroup", show: false },
          { id: "1", Header: trans('field.group'), accessor: row => rf_txTypePsGroupToDelete.current.getTable().highlightText(row["txTypePsGroup"]), width: '30%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_same_item} severity="error" value={trans('msg.same_item')} />
      <CxSnackbar xref={r_snack_op_in_progress} severity="info" value={trans('msg.operation_in_progress')} autoHideDuration={10000} />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
    </div>
  );

}

export default MxSettPsMergeGroupForm;
